import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ExistingFirmResponse, firmApi } from 'api/firm';
import { userApi } from 'api/user';
import { useAuth } from 'providers';

export const BROKER_FIRM_QUERY_KEY = 'broker-firm';

export function useBrokerFirm(): UseQueryResult<ExistingFirmResponse | null> {
  const { isSignedIn, isLoaded } = useAuth();
  const enabled = isSignedIn && isLoaded;

  return useQuery(
    [BROKER_FIRM_QUERY_KEY],
    async () => {
      const user = await userApi.getUser();
      if (!user?.id) {
        throw new Error('User not found');
      }
      return firmApi.getBrokerFirm(user.id);
    },
    { enabled, refetchOnWindowFocus: false },
  );
}
